<template lang="pug">
  tr.row
    td.col.check(v-if="!this.spMode")
      label.checkbox
        input(
          type="checkbox",
          :value="job.id",
          :checked='checked',
          :disabled="isGlobalLocked",
          @click="check($event, job.id)"
        )
    td.col(class="company_name")
      span.new(v-if="job.is_new") NEW
      a(@click="display") {{ job['company_name'] }}
    td.col(class="campany_tel")
      span {{ job['display_company_tel'] }}
    td.col(class="sales_status")
      span {{ job['sales_status'] }}
    td.col(class="assigned_to")
      span {{ job['assigned_to'] }}
    td.col(class="created_at")
      span {{ job['created_at'] }}
    td.col(class="updated_at")
      span {{ job['updated_at'] }}
    td.col(class="id")
      span {{ job['id'] }}
    td.col(class="acquisition_date")
      span {{ job['acquisition_date'] }}
    td.col(class="posting_situation")
      span.view(v-if="job.posting")
        | 掲載中
      span.view_end(v-else)
        | 終了
    td.col
      a(class="button-delete" @click="removeJobList(job.id)")
        i.fas.fa-trash-alt
        |  削除
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    props: ['job', 'modal', 'checkedIds'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked', 'spMode']),
      checked () {
        return this.checkedIds.has(this.job.id)
      },
    },
    methods: {
      ...mapMutations('job', ['clearDetail']),
      check (event, id) {
        event.preventDefault()
        const checked = event.currentTarget.checked
        this.$emit('check', { checked, id })
      },
      display (e) {
        e.stopPropagation()
        this.$emit('display', { id: this.job.id })
      },
      update () {
        this.clearDetail()
        this.$emit('update', { id: this.job.id })
      },
      async removeJobList (id) {
        // eslint-disable-next-line no-alert
        if (confirm('本当に削除しますか？')) {
          this.$store.commit('common/lockGlobal')
          try {
            await this.$store.dispatch('jobList/remove', { id })
            this.$store.commit('common/unlockGlobal')
            this.$emit('update', { id })
          } catch (e) {
            this.$store.commit('common/unlockGlobal')
          }
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobListTableRow.vue